import React from 'react'

const HowFinayoWork = () => {
  return (
    <section id="c-sectionHowFinayoWorks" className="c-sectionWrapper">
    <div className="container">
        <div className="c-sectionHeader">
            <div className="row justify-content-lg-center">
                <div className="col-lg-9 col-md-12">
                    <h5 className="c-heading46Bold">How Finayo Works</h5>
                    {/* <!-- <p className="c-para22Regular">Lorem Ipsum is simply dummy text of the printing and type and setting industry Lorem Ipsum is simply dummy .</p> --> */}
                </div>
            </div>
        </div>	

        <div className="row">
            <div className="col-12 d-flex justify-content-center">					
                <div className="c-hfwImageWrapper">
                    <img src="./images/home/howworks/finayo_how_it_works.png" className="c-hfwImg" alt="" title="" />						
                </div>
            </div>
            <div className="col-sm-12">
                <div className="c-sectionHfwSteps">
                    <div className="c-sectionHfwStep c-sectionHfwStep1">
                        <div className="c-sectionHfwStepImg">
                            <img src="./images/home/howworks/how_finayo_works_step_1.png" alt="" title="" />
                        </div>
                        <p>Visit the nearest showroom to  choose your favorite vehicle</p>
                    </div>			
                    <div className="c-sectionHfwStep c-sectionHfwStep2">
                        <div className="c-sectionHfwStepImg">								
                            <img src="./images/home/howworks/how_finayo_works_step_2.png" alt="" title="" />
                        </div>
                        <p>Scan the QR Code</p>
                    </div>
                    <div className="c-sectionHfwStepQrCode text-center">
                        <img src="./images/home/howworks/finayo_qr_code.png" className="img-fluid" alt="" title="" />
                    </div>					
                    <div className="c-sectionHfwStep c-sectionHfwStep3">
                        <div className="c-sectionHfwStepImg">
                            <img src="./images/home/howworks/how_finayo_works_step_3.png" alt="" title="" />
                        </div>
                        <p>Fill the Application</p>
                    </div>						
                    <div className="c-sectionHfwStep c-sectionHfwStep4">
                        <div className="c-sectionHfwStepImg">
                            <img src="./images/home/howworks/how_finayo_works_step_4.png" alt="" title="" />
                        </div>
                        <p>Loan Approved</p>
                    </div>
                    <div className="c-sectionHfwStep c-sectionHfwStep5">
                        <div className="c-sectionHfwStepImg">
                            <img src="./images/home/howworks/how_finayo_works_step_5.png" alt="" title="" />
                        </div>
                        <p>Take your Vehicle Home</p>
                    </div>
                </div>
            </div>
        </div>
        
        {/* <!-- <div className="text-center">
            <a href="#" className="c-btnWhiteBrdr">Get in Touch &nbsp;&nbsp; &xrarr;</a>
        </div> --> */}
    </div>
</section>
  )
}

export default HowFinayoWork